import React from "react";
import { Route, Switch } from "react-router-dom"
import MainLayout from "../layout/Main";
import EstimatePage from "./Estimate";
import ContactPage from "./Contact";

export default (props) =>
    <Switch>
        <Route
            path="/estimate"
            render={ (route) =>
                <MainLayout
                    component={EstimatePage}
                    route={route}
                    estimate={props.estimate}
                />
            }
        />
        <Route
            path="/contact"
            render={ (route) =>
                <MainLayout
                    component={ContactPage}
                    route={route}
                    estimate={props.estimate}
                />
            }
        />
    </Switch>;